<template>
  <v-dialog v-model="showProductCatalogMessage" fullscreen>
    <v-card style="overflow: hidden">
      <div style="display: flex; justify-content: center">
        <v-layout style="max-width: 1280px">
          <v-flex style="display: flex; align-items: center">
            <div class="primary--text headline pa-2">
              {{ isReplyComment ? $t('Add/Remove to cart') : $t('product_catalog.title') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab @click="cancelAddProductCatalogMessage">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <iframe
        v-if="showProductCatalogMessage"
        :key="reRenderKey"
        :src="productCatalogUrl"
        style="
          height: 100%;
          overflow: auto;
          width: 100%;
          border: none;
          position: absolute;
          inset: 60px 0 0;
        "
        sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
        allowfullscreen="true"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isReplyComment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showProductCatalogMessage: this.value,
      reRenderKey: 0,
      productCatalogMessage: undefined,
      locationOrigin: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    productCatalogUrl() {
      let baseUrl = ''
      if (window.location.hostname === 'localhost') {
        baseUrl = 'http://localhost:3500'
      } else {
        baseUrl = 'https://message-template.enterprise.zwiz.app'
      }

      const queryIsReplyComment = this.isReplyComment ? `&is_reply_comment=true` : ''

      const tempUrl = `${baseUrl}/th/product-catalog-message?page_id=${
        this.selectedBot.pageid
      }${queryIsReplyComment}&url=${this.locationOrigin}&t=${Date.now()}`

      return tempUrl
    }
  },
  watch: {
    value: function (newVal) {
      this.showProductCatalogMessage = newVal
      this.reRenderKey++
    }
  },

  mounted() {
    this.locationOrigin = window.location.origin

    window.addEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  beforeDestroy() {
    window.removeEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  methods: {
    handleListenEventMessage({ event_id, data }) {
      switch (event_id) {
        case 'zwiz-product-catalog-message-create':
          this.productCatalogMessage = JSON.stringify(data)
          this.saveAddProductCatalogMessage()
          break
        case 'zwiz-product-catalog-message-cancel':
          this.cancelAddProductCatalogMessage()
          break
      }
    },
    cancelAddProductCatalogMessage() {
      this.resetProductCatalogMessage()
      this.$emit('onCancelProductCatalog')
    },
    saveAddProductCatalogMessage() {
      const vm = this
      let tempProductCatalogMessage = null

      try {
        tempProductCatalogMessage = JSON.parse(vm.productCatalogMessage)
        vm.$emit('addProductCatalog', tempProductCatalogMessage)
      } catch (error) {
        console.log(error)
      }
      vm.showProductCatalogMessage = false
      vm.resetProductCatalogMessage()
    },
    resetProductCatalogMessage() {
      this.productCatalogMessage = '{}'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/ModalProductCatalog.vue